import {
    Badge, Button, Card, CardContent, CardTitle, Form, FormButtons, FormItem, Input, ItemList, Popup, PopupContent,
    PopupFooter, PopupTitle, Text, Toast
} from "@tv2no/ui-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createTaxYear, getTaxYearList } from "../../../../api/services/taxYear";

export const TaxYearList = () => {
    const navigate = useNavigate();
    const [showNewTaxYearPopup, setShowNewTaxYearPopup] = useState(false);
    const [newTaxYear, setNewTaxYear] = useState(null);
    const [busyCreating, setBusyCreating] = useState(false);
    const [yearList, setYearList] = useState(null);

    useEffect(() => {
        loadTaxYearList();
    }, []);

    const loadTaxYearList = () => getTaxYearList().then((res) => setYearList(res));

    const handleCreateTaxYear = () => {
        setBusyCreating(true);
        createTaxYear(newTaxYear)
            .then(() => navigate(`/import/tax/${newTaxYear}`))
            .catch((error) => {
                if (error.statusType === "CONFLICT") {
                    Toast.error("Skatteåret er allerede opprettet");
                    setBusyCreating(false);
                }
            });
    };

    return (
        <React.Fragment>
            <Card>
                <CardTitle
                    title="Datagrunnlag for skatteår"
                    actions={[
                        {
                            icon: "plus",
                            onClick: () => setShowNewTaxYearPopup(true)
                        }
                    ]}
                />
                <CardContent>
                    <ItemList onItemClick={(year) => navigate(`/import/tax/${year}`)}>
                        {yearList?.map((entry, index) => (
                            <ItemList.Item
                                index={index}
                                key={entry.year}
                                value={entry.year}
                                append={
                                    entry.published ? (
                                        <Badge fill color="success">
                                            Publisert
                                        </Badge>
                                    ) : (
                                        <Badge fill color="error">
                                            Upublisert
                                        </Badge>
                                    )
                                }
                            >
                                <Text size="medium">Skatteåret {entry.year}</Text>
                            </ItemList.Item>
                        ))}
                    </ItemList>
                </CardContent>
            </Card>

            {/* New tax year popup */}
            <Popup visible={showNewTaxYearPopup} onClose={() => setShowNewTaxYearPopup(false)}>
                <PopupTitle>Opprett skatteår</PopupTitle>
                <PopupContent>
                    <Form>
                        <FormItem label="Skatteår">
                            <Input type="number" big value={newTaxYear} onChange={setNewTaxYear} />
                        </FormItem>
                    </Form>
                </PopupContent>
                <PopupFooter>
                    <FormButtons>
                        <Button
                            type="submit"
                            color="primary"
                            icon="check"
                            onClick={handleCreateTaxYear}
                            disabled={!newTaxYear}
                            busy={busyCreating}
                        >
                            Opprett skatteår
                        </Button>
                    </FormButtons>
                </PopupFooter>
            </Popup>
        </React.Fragment>
    );
};
